import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

const Progress = React.forwardRef(({ className, value = 0, max = 100, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "relative h-4 w-full overflow-hidden rounded-full bg-gradient-to-r from-slate-100 to-slate-200 shadow-inner",
      className
    )}
    {...props}
  >
    <motion.div
      className="h-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 transition-all shadow-lg rounded-full"
      initial={{ width: 0 }}
      animate={{ width: `${(value / max) * 100}%` }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    />
  </div>
));
Progress.displayName = "Progress";

export { Progress };